"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _gbp = _interopRequireDefault(require("gbp"));
var _button = _interopRequireDefault(require("../../../../../core/button"));
var _modal = _interopRequireDefault(require("../../../../../core/modal"));
var _alert = _interopRequireDefault(require("../../../../../core/alert"));
var _occasion = _interopRequireDefault(require("occasion"));
var _typeSelector = _interopRequireDefault(require("./type-selector"));
var _entriesSelector = _interopRequireDefault(require("./entries-selector"));
var _reviewRefundCalculation = _interopRequireDefault(require("./review-refund-calculation"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // This displays a button to allow the user to cancel a MANUAL, PAID entry
// marking it as refunded.
// The user is required to make a manual refund and is reminded to do so
// via a pop-up modal
var _ref = /*#__PURE__*/_react.default.createElement(_button.default, {
  disabled: true
}, " Next ");
var _ref2 = /*#__PURE__*/_react.default.createElement(_alert.default, null, "this.state.errorMessage");
var _ref3 = /*#__PURE__*/_react.default.createElement("p", null, " Oh Dear! Something has gone wrong.");
var _ref4 = /*#__PURE__*/_react.default.createElement("p", null, "Entry could not be found");
class CancelEntryModal extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      userIs: 'selecting-entries',
      selectedEntryIDs: [this.props.entryID],
      refundType: null,
      refundAmount: 0,
      isProcessing: false,
      errorMessage: null
    });
    _defineProperty(this, "_onCloseCancel", () => {
      this.props.onClose();
    });
    _defineProperty(this, "_onChangeSelectedEntryIDs", selectedEntryIDs => {
      this.setState({
        selectedEntryIDs
      });
    });
    _defineProperty(this, "_onSelectType", () => {
      this.setState({
        userIs: 'selecting-type'
      });
    });
    _defineProperty(this, "_onChangeRefundType", refundType => {
      this.setState({
        refundType
      });
    });
    _defineProperty(this, "_onSetRefundAmount", refundAmount => {
      this.setState({
        refundAmount
      });
    });
    _defineProperty(this, "_onCalculateRefund", (paymentID, entryIDs) => {
      this.setState({
        userIs: 'reviewing-refund'
      });
    });
    _defineProperty(this, "_onBackToSelectEntries", () => {
      this.setState({
        userIs: 'selecting-entries'
      });
    });
    _defineProperty(this, "_onBackToSelectType", () => {
      this.setState({
        userIs: 'selecting-type'
      });
    });
    _defineProperty(this, "_onConfirmCancellation", () => {
      if (this.state.isProcessing) return;
      this.setState({
        isProcessing: true
      });
      switch (this.state.refundType) {
        case 'ONLINE_REFUND':
          if (this.props.refundAmount === 0) {
            this.props.onMarkEntriesAsCancelled(this.state.selectedEntryIDs, 'CANN');
          }
          return this.props.refundSelectedEntries(this.props.entry.paymentID, this.state.refundAmount, this.state.selectedEntryIDs.join(',')).then(result => {
            if (!result.success) {
              this.setState({
                errorMessage: result.error
              });
            }
          });
        case 'REMOVE':
          this.props.onRemoveEntries(this.state.selectedEntryIDs);
          break;
        case 'MANUAL':
          this.props.onMarkEntriesAsCancelled(this.state.selectedEntryIDs, 'CANR');
          break;
        default:
          this.props.onMarkEntriesAsCancelled(this.state.selectedEntryIDs, 'CANN');
      }
    });
    // *******************************************************************************
    // Modal Buttons
    // *******************************************************************************
    _defineProperty(this, "_getRefundTypeButtons", () => {
      switch (this.state.refundType) {
        case 'NO_REFUND':
          return /*#__PURE__*/_react.default.createElement(_button.default, {
            type: "warning",
            onClick: this._onConfirmCancellation,
            disabled: this.state.isProcessing
          }, "Confirm Cancellation");
        case 'MANUAL':
          return /*#__PURE__*/_react.default.createElement(_button.default, {
            type: "warning",
            onClick: this._onConfirmCancellation,
            disabled: this.state.isProcessing
          }, "Confirm Refund");
        case 'REMOVE':
          return /*#__PURE__*/_react.default.createElement(_button.default, {
            type: "danger",
            onClick: this._onConfirmCancellation,
            disabled: this.state.isProcessing
          }, "Confirm Deletion");
        case 'ONLINE_REFUND':
          return /*#__PURE__*/_react.default.createElement(_button.default, {
            type: "primary",
            onClick: this._onCalculateRefund
          }, "Next");
        default:
          return _ref;
      }
    });
    _defineProperty(this, "_getControlButtons", () => {
      switch (this.state.userIs) {
        case 'selecting-entries':
          return /*#__PURE__*/_react.default.createElement(_button.default, {
            type: "warning",
            onClick: this._onSelectType,
            disabled: !this.state.selectedEntryIDs.length
          }, "Next");
        case 'selecting-type':
          return /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_button.default, {
            onClick: this._onBackToSelectEntries
          }, " Back"), this._getRefundTypeButtons());
        case 'reviewing-refund':
          return /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_button.default, {
            onClick: this._onBackToSelectType
          }, "Back"), this.state.refundAmount > 0 && !this.state.errorMessage ? /*#__PURE__*/_react.default.createElement(_button.default, {
            type: "danger",
            onClick: this._onConfirmCancellation,
            loading: this.state.isProcessing
          }, "Confirm Refund of ", (0, _gbp.default)(+this.state.refundAmount)) : null);
        default:
          return null;
      }
    });
    _defineProperty(this, "_getModalBody", () => {
      switch (this.state.userIs) {
        case 'selecting-entries':
          return /*#__PURE__*/_react.default.createElement(_entriesSelector.default, {
            entry: this.props.entry,
            selectedEntryIDs: this.state.selectedEntryIDs,
            onChangeSelectedEntryIDs: this._onChangeSelectedEntryIDs
          });
        case 'selecting-type':
          return /*#__PURE__*/_react.default.createElement(_typeSelector.default, {
            entry: this.props.entry,
            onChangeRefundType: this._onChangeRefundType,
            refundType: this.state.refundType
          });
        case 'reviewing-refund':
          if (this.state.errorMessage) return _ref2;
          return /*#__PURE__*/_react.default.createElement(_reviewRefundCalculation.default, {
            entryID: this.props.entry.id,
            selectedEntryIDs: this.state.selectedEntryIDs,
            refundAmount: this.state.refundAmount,
            onSetRefundAmount: this._onSetRefundAmount
          });
        default:
          return _ref3;
      }
    });
  }
  render() {
    const entry = this.props.entry;
    if (!entry) {
      return /*#__PURE__*/_react.default.createElement(_modal.default, {
        title: " ",
        size: "lg",
        onClose: this._onCloseCancel
      }, _ref4);
    }

    // *******************************************************************************
    // Modal Contents
    // *******************************************************************************

    return /*#__PURE__*/_react.default.createElement(_modal.default, {
      title: this.state.userIs === 'reviewing-refund' ? 'Review Refund Calculation' : this.state.userIs === 'selecting-entries' ? 'Select Entries' : 'Cancel Selected Entries',
      buttons: /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_button.default, {
        onClick: this._onCloseCancel
      }, "Do Not Cancel Entries"), this._getControlButtons()),
      size: "lg",
      onClose: this._onCloseCancel
    }, this._getModalBody());
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _ref5 = _mergeBqlQueries(_mergeBqlQueries({
  id: true,
  entryStatusRef: true,
  paymentID: true
}, _entriesSelector.default.partialQueries.Entry), _typeSelector.default.partialQueries.Entry);
var _default = exports.default = (0, _reactBicycle.connect)(CancelEntryModal, props => ({
  ["entry(entryID:" + JSON.stringify(props.entryID) + ")"]: _ref5
}), (client, props) => ({
  onMarkEntriesAsCancelled(entryIDs, newEntryStatusRef) {
    return client.update('Entry.markEntriesAsCancelled', {
      entryIDs,
      newEntryStatusRef
    });
  },
  onRemoveEntries(entryIDs) {
    return client.update('Entry.removeEntries', {
      entryIDs
    });
  },
  refundSelectedEntries(paymentID, refundAmount, entryIDsToRefund) {
    return client.update('Refund.createRefundAndCancelEntries', {
      paymentID,
      refundAmount,
      entryIDsToRefund
    });
  }
}));